/* globals CKEDITOR */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import translate from '../translate';
import FormGroup from './FormGroup';
import FormLabel from './FormLabel';

const defaultToolbar = [
  { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
  { name: 'styles', groups: ['styles'] },
  { name: 'colors', groups: ['colors'] },
  { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph'] },
  { name: 'document', groups: ['mode', 'document', 'doctools'] },
  { name: 'clipboard', groups: ['clipboard', 'undo'] },
  { name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing'] },
  { name: 'forms', groups: ['forms'] },
  { name: 'links', groups: ['links'] },
  { name: 'insert', groups: ['insert'] },
  { name: 'tools', groups: ['tools'] },
  { name: 'others', groups: ['others'] },
  { name: 'about', groups: ['about'] },
];

const defaultRemoveButtons =
  // eslint-disable-next-line max-len
  'Save,Templates,NewPage,Source,ExportPdf,Preview,Print,RemoveFormat,Superscript,Subscript,Underline,Strike,BidiLtr,BidiRtl,Language,CreateDiv,Blockquote,Outdent,Indent,Cut,Undo,Redo,Copy,Paste,PasteText,PasteFromWord,Find,SelectAll,Scayt,Replace,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe,Form,Checkbox,Radio,TextField,Textarea,Select,Button,HiddenField,ImageButton,Anchor,Unlink';

const CustomHTMLEditor = props => {
  const {
    groupProps,
    label,
    id,
    tooltip,
    labelClassName,
    containerClassName,
    inputClassName,
    placeholder,
    name,
    value,
    onChange,
    disabled,
    inputProps,
    hint,
  } = props;

  useEffect(() => {
    let editor;
    $(document).ready(() => {
      editor = CKEDITOR.replace(id,
        {
          toolbarGroups: defaultToolbar,
          removeButtons: defaultRemoveButtons,
          uiColor: '#FFFFFF',
        });
      if (editor) {
        editor.on('change', function () {
          onChange(id, this.getData());
        });
      }
    });
  }, []);

  return (
    <FormGroup {...groupProps}>
      {label && (
        <FormLabel
          id={id}
          label={label}
          tooltip={tooltip}
          className={labelClassName}
        />
      )}
      <div className={containerClassName}>
        <textarea
          className={`form-control m-input ${inputClassName}`}
          id={id}
          placeholder={placeholder}
          name={name}
          value={value}
          onChange={({ currentTarget }) => onChange(currentTarget.value)}
          disabled={disabled}
          {...inputProps}
        />
        {hint && <span className="m-form__help">{hint}</span>}
      </div>
    </FormGroup>
  );
};


/** NOTE:
 * If you need to use de required option
 * see the Journey.jsx when the FormWizardValidation is init
 */
CustomHTMLEditor.propTypes = {
  inputClassName: PropTypes.string,
  containerClassName: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.bool,
    PropTypes.shape({}),
  ]),
  onChange: PropTypes.func,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  label: PropTypes.string,
  labelClassName: PropTypes.string,
  disabled: PropTypes.bool,
  hint: PropTypes.string,
  inputProps: PropTypes.shape(),
  tooltip: PropTypes.string,
  groupProps: PropTypes.shape({}),
};

CustomHTMLEditor.defaultProps = {
  inputClassName: '',
  containerClassName: '',
  id: undefined,
  name: undefined,
  onChange: undefined,
  placeholder: undefined,
  label: undefined,
  labelClassName: undefined,
  value: '',
  disabled: false,
  hint: undefined,
  inputProps: {},
  tooltip: '',
  groupProps: {},
};

export default translate(CustomHTMLEditor);
